import React, {useContext, useEffect} from 'react';
import { InputContext } from '../contexts/InputContext';
import { Link } from "react-router-dom";

const HeaderBody = () => {
  const [authInformation, setAuthInformation, showSideMenu, setShowSideMenu, checkSignIn] = useContext(InputContext)

  useEffect(() => {
    checkSignIn()
  }, []);

  return (
    <nav className="navbar navbar-main navbar-expand-lg px-0 mx-4 shadow-none border-radius-xl" id="navbarBlur" navbar-scroll="true">
      <div className="container-fluid py-1 px-3">
        <nav aria-label="breadcrumb">
          <h6 className="font-weight-bolder mb-0">{ authInformation.autenticado === true ? `Bienvenid@ ${authInformation.nombre} (${authInformation.rol})` : '' }</h6>
        </nav>
        <div className="collapse navbar-collapse mt-sm-0 mt-2 me-md-0 me-sm-4" id="navbar">
          <div className="ms-md-auto pe-md-3 d-flex align-items-center">

          </div>
          <ul className="navbar-nav  justify-content-end">
            {/* <li className="nav-item d-flex align-items-center">
              <a className="btn btn-outline-primary btn-sm mb-0 me-3" target="_blank" href="https://www.creative-tim.com/builder?ref=navbar-soft-ui-dashboard">Online Builder</a>
            </li> */}
            <li className="nav-item d-flex align-items-center">
              {
                authInformation.autenticado === true ? (
                  <Link className="nav-link text-body font-weight-bold px-0" to="/salir" >
                    <i className="fa fa-user me-sm-1"></i>
                    <span className="d-sm-inline d-none">Salir</span>
                  </Link>
                ) : (
                  <>
                  <Link className="nav-link text-body font-weight-bold px-0" to="/ingreso" >
                    <i className="fa fa-user me-sm-1"></i>
                    <span className="d-sm-inline d-none">Ingresar</span>
                  </Link>
                  </>
                )
              }

            </li>
            <li className="nav-item d-xl-none ps-3 d-flex align-items-center">
              <a href="#" onClick={() => setShowSideMenu( !showSideMenu )} className="nav-link text-body p-0" id="iconNavbarSidenav">
                <div className="sidenav-toggler-inner">
                  <i className="sidenav-toggler-line"></i>
                  <i className="sidenav-toggler-line"></i>
                  <i className="sidenav-toggler-line"></i>
                </div>
              </a>
            </li>
            {/* <li className="nav-item px-3 d-flex align-items-center">
              <a href="#" className="nav-link text-body p-0">
                <i className="fa fa-cog fixed-plugin-button-nav cursor-pointer"></i>
              </a>
            </li> */}
            <li className="nav-item dropdown pe-2 d-flex align-items-center">
              {/* <a href="#" className="nav-link text-body p-0" id="dropdownMenuButton" data-bs-toggle="dropdown" aria-expanded="false">
                <i className="fa fa-bell cursor-pointer"></i>
              </a> */}
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default HeaderBody;